import { Form, FormItemProps, Switch, SwitchProps } from "antd";
import { FunctionComponent } from "react";

export type SwitchFormItemProps = SwitchProps & FormItemProps & {
    testid?: string;
};

export const SwitchFormItem: FunctionComponent<SwitchFormItemProps> = ({ name, label, required, testid, ...rest }) => {

    return (
        <Form.Item name={name.split(".")} label={label} valuePropName="checked">
            <Switch {...rest} {...({ testid: testid ?? name } as any)} />
        </Form.Item>
    );

}